













import { Component, Prop, Vue } from "vue-property-decorator";

import ServiceMenuStatusIcon from "@/components/service-status/ServiceMenuStatusIcon.vue";
import {
  SERVICE_MENU_STATUS_NAME,
  ServiceMenuStatus,
  ServiceMenuStatusIconType,
} from "@/consts/const";

@Component({
  components: { ServiceMenuStatusIcon },
})
export default class ServiceMenuStatusIconWithText extends Vue {
  @Prop({ required: true }) private status!: ServiceMenuStatus;
  private ServiceMenuStatusIconType = ServiceMenuStatusIconType;
  private SERVICE_MENU_STATUS_NAME = SERVICE_MENU_STATUS_NAME;
}
